export enum UserType {
    ADMIN = "ADMIN",
    SUBADMIN = "SUBADMIN",
    EMPLOYEE = "EMPLOYEE",
    STATION = "STATION",
    PARTICIPANT = "PARTICIPANT",
    SUSPECT = "SUSPECT",
    SPAMMER = "SPAMMER"
}
